import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useState } from 'react';
import { FaTimes, FaUser, FaEnvelope, FaPhone } from 'react-icons/fa';
import { customBaseUrl, httpPost } from '../../store/http';
import { hideLoader, showLoader } from '../../utils/loader';
import Swal from 'sweetalert2';
import { NotificationManager } from 'react-notifications';

function CreateMarketer({ modalState, modalCloseAction, refreshData }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleClose = () => {
    modalCloseAction();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !firstName || !lastName || !phoneNumber) {
      return NotificationManager.error("Please fill all required fields");
    }

    if (phoneNumber.length !== 13 || !phoneNumber.startsWith('234')) {
      return Swal.fire('Invalid Phone Number', 'Phone number must be 13 digits and start with 234', 'error');
    }

    showLoader();

    let data = {
      "email": email,
      "phoneNumber": phoneNumber,
      "firstName": firstName,
      "lastName": lastName,
    };

    try {
      const res = await httpPost(`${customBaseUrl.cardUrl}/cms/admin/marketers/register`, data);
      hideLoader();
      if (res?.status === true) {
        Swal.fire('Success', res?.message || "Marketer created successfully", 'success');
        if (refreshData) refreshData();
        handleClose();
      } else {
        Swal.fire('Oops!', res?.message || "Failed to create marketer", 'error');
      }
    } catch (err) {
      hideLoader();
      Swal.fire('Error', "An unexpected error occurred", 'error');
    }
  };

  return (
    <Modal
      open={modalState}
      onClose={handleClose}
      aria-labelledby="create-marketer-modal"
      className="premium-modal-wrapper"
    >
      <Box className="premium-modal-container" sx={{ width: 500 }}>
        <div className="modal-header">
          <h2>Create Field Marketer</h2>
          <button className="close-btn" onClick={handleClose}>
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="premium-form">
          <div className="form-row">
            <div className="input-group">
              <label>First Name</label>
              <div className="input-with-icon">
                <FaUser className="input-icon" />
                <input
                  type="text"
                  placeholder="Enter first name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="input-group">
              <label>Last Name</label>
              <div className="input-with-icon">
                <FaUser className="input-icon" />
                <input
                  type="text"
                  placeholder="Enter last name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="input-group">
              <label>Email Address</label>
              <div className="input-with-icon">
                <FaEnvelope className="input-icon" />
                <input
                  type="email"
                  placeholder="example@waya.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="input-group">
              <label>Phone Number</label>
              <div className="input-with-icon">
                <FaPhone className="input-icon" />
                <input
                  type="text"
                  placeholder="234XXXXXXXXXX"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                  title="Phone number must start with 234 and be 13 digits"
                />
              </div>
              <small className="input-help">Must start with 234 (e.g. 2348012345678)</small>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={handleClose}>
              Cancel
            </button>
            <button type="submit" className="btn-primary">
              Create Marketer
            </button>
          </div>
        </form>
      </Box>
    </Modal>
  );
}

export default CreateMarketer;